import { Container } from './Container';
import { Emoji } from './Emoji';
import { TitleText } from './TitleText';
import { SubtitleText } from './SubtitleText';
import { EmailLink } from './EmailLink';

export default {
  Container,
  Emoji,
  TitleText,
  SubtitleText,
  EmailLink,
};
